import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationPL from './locales/pl/translation.json';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationFR from './locales/fr/translation.json';
import translationUK from './locales/uk/translation.json';
import translationCS from './locales/cs/translation.json';

const resources = {
    pl: {
        translation: translationPL,
    },
    en: {
        translation: translationEN,
    },
    de: {
        translation: translationDE,
    },
    fr: {
        translation: translationFR,
    },
    uk: {
        translation: translationUK,
    },
    cs: {
        translation: translationCS,
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'pl', // Default language
        fallbackLng: 'pl',
        interpolation: {
            escapeValue: false, // React already safe from XSS
        },
    });

export default i18n;
